import { Component, computed, inject, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { NgClass } from '@angular/common';
import { NotificationV2Service } from '@app/notification-v2.service';

@Component({
  selector: 'app-notification-v2',
  imports: [NgClass],
  templateUrl: './notification-v2.component.html',
  styleUrl: './notification-v2.component.scss',
})
export class NotificationV2Component implements OnInit, OnDestroy {
  notificationService = inject(NotificationV2Service);

  private _notificationsFromService = toSignal(this.notificationService.notificationsEvent);
  notifications = computed(() => {
    return this._notificationsFromService().map((notif) => {
      return {
        ...notif,
        message: this.getFormattedMessage(notif.message),
      };
    });
  });

  responseChannel = this.notificationService.responseChannel;

  isDestroyed$ = new Subject<boolean>();

  displayBackdrop = computed(() => {
    return this.notifications().some((notif) => notif.backdropVisible);
  });

  ngOnInit(): void {
    // this.notificationService.notificationsEvent.pipe(takeUntil(this.isDestroyed$)).subscribe((notifications) => {
    //
    // })
  }
  ngOnDestroy() {
    this.isDestroyed$.next(true);
    this.isDestroyed$.complete();
  }

  respond(hash: string, booleanResponse: boolean) {
    this.responseChannel.next({ hash, booleanResponse });
  }

  onBackdropClick(event: MouseEvent) {
    event.stopPropagation();
    this.notificationService.onBackdropClick();
  }

  /**
   * Formats a message string by adding `<br/>` elements to aim for equal line lengths.
   * @param message
   * @private
   */
  private getFormattedMessage(message: string): string {
    if (!message || typeof message !== 'string') {
      return message;
    }

    // desired line length in characters
    const lineLength = 44;
    // don't break short messages and allow some leeway
    if (message.length <= lineLength * 1.25) {
      return message;
    }

    // how many lines should the message be split into
    const lineCount = Math.ceil(message.length / lineLength);
    const words = message.split(' ');
    const avgWordsPerLine = Math.floor(words.length / lineCount);
    // contains indexes to indicate where to insert line breaks
    const brakePositions = Array(lineCount - 1)
      .fill(0)
      .map((_, index) => (index + 1) * avgWordsPerLine);

    let newMessage = '';
    words.forEach((word, index) => {
      newMessage += word + ' ';
      if (brakePositions.includes(index)) {
        newMessage += '<br/>';
      }
    });

    return newMessage;
  }
}
